import { CompassCardUI } from '@scale/compass-ui/types';
import {
  type UpdateDirectAssignmentSchemaType,
  type UpdateDirectAssignmentContext,
  UpdateDirectAssignmentCardShared,
  UPDATE_DIRECT_ASSIGNMENT,
} from '@scale/genai-compass-shared/cards/update_direct_assignment';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import UpdateDirectAssignmentCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateDirectAssignmentCard/UpdateDirectAssignmentCardComponent';

export const DEFAULT_EXPIRE_DATE = undefined; // DAs do not expire by default
export const DEFAULT_EXPIRE_HOUR = 17; // If a date is added, the DA will be set to expire at 5pm UTC

const defaultContext: UpdateDirectAssignmentContext = {
  cardType: UPDATE_DIRECT_ASSIGNMENT,
  columnIdWithWorkerIds: '',
  assignments: [{ projectId: '', reviewLevel: undefined, expiresAt: DEFAULT_EXPIRE_DATE }],
  overwrite: false,
  removeAllAssignments: false,
};

export const UpdateDirectAssignmentCardInfo: CompassCardUI<
  UpdateDirectAssignmentSchemaType,
  UpdateDirectAssignmentContext
> = {
  ...UpdateDirectAssignmentCardShared,
  title: 'Update Direct Assignments',
  icon: 'edit',
  toolTip: "Update each worker's direct assignments",
  defaultContext,
  showOutput: true,
  button: {
    icon: faArrowRight,
  },
  legacyComponent: UpdateDirectAssignmentCardComponent,
};

export const ADD_REMOVE_OPTIONS = [
  {
    id: 'add',
    name: 'Add',
  },
  {
    id: 'remove',
    name: 'Remove',
  },
];

export const ASSIGNMENT_RANK_OPTIONS = [
  {
    id: 'push',
    name: 'Push to end (default)',
  },
  {
    id: 'top',
    name: 'Top',
  },
  {
    id: 'second',
    name: 'Second',
  },
  {
    id: 'bottom',
    name: 'Bottom',
  },
];
